import React from 'react';
import './FourKeys.css';
import animals from "../../img/fourKeys/animals.png";
import army from "../../img/fourKeys/army.png";
import chats from "../../img/fourKeys/chats.png";
import fundreizing from "../../img/fourKeys/fundreizing.png";
import humhelp from "../../img/fourKeys/hum-help.png";
import tablets from "../../img/fourKeys/tablets.png";
import IsraelHistory from "../../img/fourKeys/israelHistory.png";
import Pidgotovka from "../../img/fourKeys/pidgotovka.png";
import Dopomoga from "../../img/fourKeys/dopomoga.png";
import Organisation from "../../img/fourKeys/organisation.png";
import i18n from "i18next";
import { t } from "i18next";


const FourKeys = (props) => {
    const state = {
        FourKeys_item: [
        // {
        //     img: organization,
        //     title: 'Організаційна структура',
        //     text: 'Рекрутмент та підготовка волонтерів, як організувати процес роботи та комунікації, IT - інфраструктура штабу, мотивація та психологія у роботі з командою.',
        // },
        // {
        //     img: medicines,
        //     title: 'Ліки',
        //     text: 'Шляхи постачання, організації, що надають допомогу, закупівля, особливі умови ввозу в Україну, склади, необхідні документи.',
        // },
        // {
        //     img: evacuation,
        //     title: 'Евакуація',
        //     text: 'Транспорт, гарячі точки, зелені коридори, координація з місцевими органами влади, безпека, правила.',
        // },
        // {
        //     img: logistic,
        //     title: 'Логістика',
        //     text: 'Транспорт, маршрути, перевізники, склади та хаби, умови ввозу в Україну, необхідні документи.',
        // },
        // {
        //     img: vpo,
        //     title: 'ВПО в Україні',
        //     text: 'Куди їхати, де ще є місця, транспорт, маршрути, безпека, гуманітарна допомога, психологічна підтримка.',
        // },
        // {
        //     img: board,
        //     title: 'КОРДОН',
        //     text: 'Як краще дістатись до кожного із кордонів, що з собою мати, маршрути, перевізники, правила, особливості перетину, які потрібно знати.',
        // },
        // {
        //     img: abroad,
        //     title: 'ЗА КОРДОНОМ',
        //     text: 'Особливості кожної країни для біженців: реєстрація, документи, пільги, дозвіл на роботу, прихисток, безпека.',
        // },
        {
            img: IsraelHistory,
            title: i18n.t("fourKeys.item1.title"),
            text: i18n.t("fourKeys.item1.desc"),
        },
        {
            img: army,
            title: i18n.t("fourKeys.item2.title"),
            text: i18n.t("fourKeys.item2.desc"),
        },
        {
            img: Pidgotovka,
            title: i18n.t("fourKeys.item3.title"),
            text: i18n.t("fourKeys.item3.desc"),
        },
        {
            img: Dopomoga,
            title: i18n.t("fourKeys.item4.title"),
            text: i18n.t("fourKeys.item4.desc"),
        },
        {
            img: Organisation,
            title: i18n.t("fourKeys.item5.title"),
            text: i18n.t("fourKeys.item5.desc"),
        },
      ],
    };

    const renderFourKeys_item = (item, i) => {
        return (
            <div className="fourKeys_item" key={`FourKeys_item-${i}`}>
                <div className="fourKeys_item-content" >
                    <div className='fourKeys_item-info fourKeys_item-half'>
                        <p className='fourKeys_item-info-title'>{item.title}</p>
                        <p className='fourKeys_item-info-text'>{item.text}</p>
                    </div>
                    <div className='fourKeys_item-half fourKeys_item-img_block'>
                        <img src={item.img} className="fourKeys_item_image" alt="" />
                    </div>
                </div>
            </div>
        );
    };

    return (
        <div className="fourKeys" id='topics'>
            <div className="container">
                <h3 className="fourKeys_title">{t("fourKeys.title1")}<br/><span className="fourKeys_title--small">{t("fourKeys.title2")}</span></h3>
                <p className="fourKeys_under-topic">{t("fourKeys.desc")}</p>
                <p className="fourKeys_under-title">{t("fourKeys.program_block")}</p>
                <div>
                    {state.FourKeys_item.map((item, i) => renderFourKeys_item(item, i))}
                </div>
            </div>
        </div>
    );
};

export default FourKeys;